export default "/images/vendor/flag-icons/flags/4x3/kr.svg?014570f16b8183e5b49890b7c090a256";